import Vue from 'vue';
import App from './App';
import { router } from '@/router/router.js';


//只在本地开发环境使用，用于获取用户相关信息
// if (process.env.NODE_ENV === 'development') {
//   require('./getUserInfo')
// }
import Loading from '@/components/loading/loading.js'
Vue.use(Loading)
import { Notify } from 'vant';
Vue.use(Notify);


// // 引入路由卫士
// import { guardHandler } from '@/router/guard.js'
//   // 路由卫士
//   guardHandler(router)
new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
